import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import 'antd/dist/reset.css';
import './assets/scss/main.scss';
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./_redux/store";
import { AuthProvider } from "./_hooks/useAuthContext";

const Root = () => {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </Provider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
